import { render, staticRenderFns } from "./ErrorPayment.vue?vue&type=template&id=59bb4cec&scoped=true&"
import script from "./ErrorPayment.vue?vue&type=script&lang=js&"
export * from "./ErrorPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bb4cec",
  null
  
)

export default component.exports